const MINIMUM_AGE = 18;

/** Returns the user's age in whole years given their date of birth. */
export function getAge(dateOfBirth: Date): number {
  const today = new Date();
  const todayYear = today.getUTCFullYear();
  const todayMonth = today.getUTCMonth();
  const todayDate = today.getUTCDate();
  const dobYear = dateOfBirth.getUTCFullYear();
  const dobMonth = dateOfBirth.getUTCMonth();
  const dobDate = dateOfBirth.getUTCDate();
  let age = todayYear - dobYear;
  if (
    todayMonth < dobMonth ||
    (todayMonth === dobMonth && todayDate < dobDate)
  ) {
    age--;
  }
  return age;
}

/** Returns true if the user is at least 18 years old. */
export function isMinimumAge(dateOfBirth: Date): boolean {
  return getAge(dateOfBirth) >= MINIMUM_AGE;
}
